import { RiUserForbidLine } from "react-icons/ri";
import { TbMessageReport } from "react-icons/tb";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateMessageOptions } from "../../../store/Slices/MessageOptionsSlice";
import { MdLogout } from "react-icons/md";
import TextTranslate from "../../../utils/TextTranslate";

const rowClass =
  "flex w-full cursor-pointer items-center gap-3 px-4 py-3.5 text-left text-[15px] text-[#FF3B30] active:bg-black/[0.04] dark:active:bg-white/[0.06]";

export default function GroupActions() {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );
  const dispatch = useAppDispatch();

  const targetName =
    currentConversationData.chat_type == "group"
      ? currentConversationData.group_name
      : currentConversationData.user_name;

  return (
    <div className="overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      {currentConversationData.chat_type == "private" && (
        <button
          type="button"
          onClick={() =>
            dispatch(
              updateMessageOptions({
                showModal: true,
                title: `Are you sure you want ${currentConversationData.is_group_blocked ? "Unblock" : "Block"} ${currentConversationData.user_name}?`,
                description: "",
                modalName: "block_user",
              }),
            )
          }
          className={rowClass}
        >
          <RiUserForbidLine className="text-lg" />
          <span>
            <TextTranslate
              text={
                currentConversationData.is_group_blocked ? "Unblock" : "Block"
              }
            />{" "}
            {targetName}
          </span>
        </button>
      )}

      <button
        type="button"
        onClick={() =>
          dispatch(
            updateMessageOptions({
              modalName: "report_user",
            }),
          )
        }
        className={`${rowClass} ${
          currentConversationData.chat_type == "private"
            ? "border-t border-black/[0.06] dark:border-white/[0.08]"
            : ""
        }`}
      >
        <TbMessageReport className="text-lg" />
        <span>
          <TextTranslate text="Report" /> {targetName}
        </span>
      </button>

      {currentConversationData.chat_type == "group" && (
        <button
          type="button"
          onClick={() => {
            dispatch(
              updateMessageOptions({
                showModal: true,
                title: `Are you sure you want to Exit from ${currentConversationData.group_name}?`,
                description: "",
                modalName: "exit_from_group",
              }),
            );
          }}
          className={`${rowClass} border-t border-black/[0.06] dark:border-white/[0.08]`}
        >
          <MdLogout className="text-lg" />
          <span>
            <TextTranslate text="Exit From Group" />
          </span>
        </button>
      )}
    </div>
  );
}
